module.exports = __webpack_public_path__ + "static/knittedstripehamper1-a09bc99e96395f95005700f39ff2c909.jpeg";